<template>
  <div></div>
</template>

<script>
export default {
  name: "shareLink",
  components: {},
  computed: {},
  data() {
    return {
      openlink: "weixin://dl/business/?appid=wx8724949e04cece0f&path=pages/home/home",
    };
  },
  created() {
    // this.openlink = "weixin://dl/business/?t=Oa8UQlNZnGc";
  },
  mounted() {
    this.judge()
  },
  methods: {
    /**
     *  判断运行环境
     */
    isWorkClient() {
      var ua = navigator.userAgent.toLowerCase();
      var isWXWork = ua.match(/wxwork/i) == "wxwork";
      var isWeixin = !isWXWork && ua.match(/micromessenger/i) == "micromessenger";
      var isMobile = false;
      var isDesktop = false;
      if (
        navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|IEMobile)/i
        )
      ) {
        isMobile = true;
      } else {
        isDesktop = true;
      }
      if (isWeixin) {
      } else if (isDesktop) {
      } else if (isWXWork) {
        // 判断是否是企微环境
        return true;
      } else {
      }
      return false;
    },
    judge() {
      this.jump();
    },
    jump() {
      if (this.isWorkClient()) {
        // 企微环境直接跳详情
        this.$router.push({
          path: "/",
          name: "toDoPage",
        });
      } else {
        // 跳转小程序
        location.href = this.openlink;
      }
    },
  },
};
</script>
